import moment from "../../moment";

// 経路検索→予約の場合のqueryの変換(日にち)
export const convertQueryDate = (date) => {
  if (date == undefined || date == null) {
    return moment(new Date()).format("YYYY-MM-DD");
  } else {
    const year = date.substr(0, 4);
    const month = date.substr(4, 2);
    const day = date.substr(6, 2);
    return moment(new Date(year, month - 1, day)).format("YYYY-MM-DD");
  }
};
